<template>
  <div
    :class="style.answer"
    v-if="isSimpleCheckBox"
    :contentType="insertNonBreakingSpaces(variant?.text || '')"
  >
    <input
      @change="checkboxHandler($event)"
      :name="question?.question"
      :id="inputId"
      :type="question?.type?.split('-')[0]"
    />
    <label
      :class="getClassAnswerImg(question as questions)"
      :style="{
        flexDirection: !question?.vertical ? 'row' : undefined,
        border: isChecked ? '2px solid #9f63fc' : undefined
      }"
      :for="inputId"
    >
      <div
        :class="style.imgBack"
        id="pictureHere"
        v-if="question?.type.split('-')[1] === 'img'"
        :data-img="variant?.img"
      />
      <div :class="style.content">
        <span
          :class="style.fakeBefore"
          v-if="question?.type.split('-')[0] === 'checkbox'"
        />
        <span
          v-html="insertNonBreakingSpaces(variant?.text || '')"
          :class="style.textContent"
        ></span>
      </div>
    </label>
  </div>

  <div v-else :class="style.checkboxForm">
    <div :class="[connection?.text === answer?.connection ? style.active : '']">
      <input
        type="radio"
        :id="inputId"
        name="notAnswer"
        ref="radioInputQuestion"
      />
      <label :class="style.answerImg" :for="inputId">
        <div>
          <span :class="style.fakeBefore" />
          <span v-text="connection?.text"></span>
        </div>
      </label>
    </div>
  </div>
</template>

<script lang="ts">
import {questions, QuestionVariant} from "@/page/quiz/typeQuiz";
import style from "./CheckBoxRadioButton.module.scss";
import {insertNonBreakingSpaces} from "@/scripts/typographer";
import {defineComponent, PropType} from "vue";

export default defineComponent({
  name: "CheckBoxRadioButton",
  props: {
    isSimpleCheckBox: {
      type: Boolean,
      default: true
    },
    connection: Object,
    question: {
      type: Object as PropType<questions>,
      required: false
    },
    variant: {
      type: Object as PropType<QuestionVariant>,
      required: false
    },
    answer: Object,
    answerInput: {
      // eslint-disable-next-line no-unused-vars
      type: Function as PropType<(event: Event) => void>,
      required: false
    },
    getConnectionList: Function,
    updateAnswerRadio: Function
  },
  emits: ["sendRefCheckBox"],
  data() {
    return {
      style,
      isChecked: false,
      // уникальный ID для каждого экземпляра компонента
      inputId:
        "input-" + Math.random().toString(36).substring(2, 9) + "-" + Date.now()
    };
  },
  mounted() {
    if (!this.isSimpleCheckBox) {
      this.$emit("sendRefCheckBox", this.$refs.radioInputQuestion);
    }
  },
  methods: {
    insertNonBreakingSpaces,
    checkboxHandler(event: Event) {
      this.isChecked = !this.isChecked;
      const target = event.target as HTMLInputElement;

      if (this.answerInput) {
        this.answerInput(event);
      }

      if (target.type === "radio") {
        setTimeout(() => {
          target.checked = false;
          this.isChecked = false;
        }, 1500);
      }
    },
    getClassAnswerImg(question: questions) {
      let classAnswerImg = style.answerImg;
      if (question?.type?.split("-")[1] === "img") {
        classAnswerImg += " " + style.withImg;
      }
      if (question?.vertical && !this.mobileVersion) {
        classAnswerImg += " " + style.vertical;
      }
      return classAnswerImg;
    }
  },
  computed: {
    mobileVersion(): boolean {
      return this.$quizStore.getMobileVersion;
    }
  }
});
</script>
